import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { RootState } from "store";
import CreateAsset from "modules/Campaigns/CampaignAssets/Components/CreateAsset";
import Message from "modules/Common/Components/Message";
import { getQueryParam } from "utils";
import ButtonSmall from "../../../Common/Components/ButtonSmall";
import Button from "modules/Common/Components/Button";
import { ALERT_MESSAGES } from "constants/messages";

interface IAssetWithoutCampaignAudience {}

const AssetWithoutCampaignAudience: React.FC<IAssetWithoutCampaignAudience> = (props) => {
  const assetName: any = useSelector((state: RootState) => state.assetWithoutCampaignDetails.assetName);
  const assetId = getQueryParam("asset_id");
  return (
    <Wrapper>
      <Message
        iconClass={"message-icon-style"}
        message={ALERT_MESSAGES.DEFAULT_EMAIL_WITHOUT_CAMPAIGN}
        label="Heads up!"
        type="info"
        callToAction={() => {
          return (
            <CreateAsset
              noPortal={true}
              noDropdown={true}
              updateAsset={true}
              assetId={assetId?.toString()}
              name={assetName}
            >
              <span className="save-to-campaign">
                <ButtonSmall style={{ marginRight: "15px" }} value={"Save"} />
              </span>
            </CreateAsset>
          );
        }}
      />

      <div className="message-container">
        <h2 className="grey-text padding-top-lg padding-left-xl">
          You haven’t added any people or lists to this asset yet. Once you do, any time you publish, any contacts
          and lists added will receive the new edition automatically
        </h2>
        <CreateAsset
          noPortal={true}
          noDropdown={true}
          updateAsset={true}
          assetId={assetId?.toString()}
          name={assetName}
        >
          <Button className="btn-sm-primary " value="Save to a Campaign to add Contacts & Lists" />
        </CreateAsset>
      </div>
    </Wrapper>
  );
};

export default AssetWithoutCampaignAudience;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  .message-wrapper {
    margin-bottom: 138px;
  }
  .message-container {
    flex: 1;
    padding: 2% 19%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      color: #424b50;
      font-family: "Roboto Slab", serif;
      font-weight: 600;
      margin-bottom: 5%;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 20px;
      }
    }
  }
`;
